import React from "react";
import { arrowDownBlack, locationIcon, bannerPhoto } from "../../images";
import styles from "../course/course-header/header.module.css";
import Button from "../button";

const regionCourseInfo = {
  "US & Canada": {
    project: {
      label: "New client project",
      value: "every week",
      description: "5 people per project group",
    },
    duration: {
      label: "Duration",
      value: "10 weeks",
      description: "plus presentation week",
    },
    session: {
      label: "Project Session",
      value: "Tuesdays, 7PM EST",
      description: "",
    },
  },
  "Europe - Africa": {
    project: {
      label: "New client project",
      value: "every week",
      description: "5 people per project group",
    },
    duration: {
      label: "Duration",
      value: "10 weeks",
      description: "plus presentation week",
    },
    session: {
      label: "Project Session",
      value: "Tuesdays, 7PM GMT+1",
      description: "",
    },
  },
};

const TechCourseHeader = ({
  regions = ["US & Canada", "Europe - Africa"],
  defaultRegion = "US & Canada",
  bannerTile = "Tech Experience Program",
  bannerMessage = "Gain real-world experience in tech with hands-on projects.",
  setIsModalOpen = () => {},
  scrollToPayments = () => {},
  selectedRegion,
  onRegionChange,
}) => {
  const [open, setOpen] = React.useState(false);
  const [showForm, setShowForm] = React.useState(false);
  const info = regionCourseInfo[selectedRegion || defaultRegion];

  return (
    <section className={styles.section_no_background}>
      <div className={styles.top_banner}>
        <div className={styles.banner_info}>
          <div className={styles.banner_text}>
            <div className={styles.tag}>No previous work experience needed!</div>
            <div className={styles.banner_title}>{bannerTile}</div>
            <div className={styles.banner_message}>{bannerMessage}</div>
          </div>
          <div className={styles.banner_button}>
            <Button 
              className={styles.enrol_now} 
              onClick={() => setShowForm(true)}
            >
              Join a Project
            </Button>
            <Button
              outline="black"
              variant="secondary"
              className={styles.download_brochure}
              onClick={scrollToPayments}
            >
             View Pricing 
            </Button>
          </div>
        </div>
        <div className={styles.banner_photo}>
          <img src={bannerPhoto} alt="banner" />
        </div>
      </div>
      
    {/* Modal for the form */} 
        {showForm && (
          <div 
            style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
            }}
            onClick={() => setShowForm(false)}
          >
            <div 
          style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            width: '90%',
            maxWidth: '800px',
            height: '90%',
            maxHeight: '600px',
            position: 'relative',
            padding: '20px'
          }}
          onClick={(e) => e.stopPropagation()}
            >
          <button
            onClick={() => setShowForm(false)}
            style={{
              position: 'absolute',
              top: '10px',
              right: '15px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
          <iframe 
            title='Business Analysis Work Experience (Project-Based)'
            aria-label='Business Analysis Work Experience (Project-Based)' 
            frameBorder="0" 
            style={{
              height: '500px',
              width: '99%',
              border: 'none'
            }} 
            src='https://forms.zohopublic.com/info6463/form/BusinessAnalysisWorkExperienceProjectBased/formperma/4wqRaRle4RPPKYXJrDTcqonpUhKcy8rNgAEZ0kx3MIg'
          />
            </div>
          </div>
        )}
        
        <div className={styles.first_course_inf}>
          {regions && regions.length > 0 && (
            <div className={styles.inf_point}>
          <div className={styles.point}>Region</div>
          <div className={styles.select_cont}>
            <div className={styles.select_dropdown}>
              <div
            className={styles.select}
            onClick={() => setOpen(!open)}
            style={{ cursor: "pointer" }}
              >
            <img src={locationIcon} alt="location-icon" />
            <span>{selectedRegion || defaultRegion}</span>
            <img
              className={styles.arrow}
              src={arrowDownBlack}
              alt="dropdown arrow"
            />
              </div>
              {open && (
            <div className={styles.select_options}>
              {regions.map((region) => (
                <div
              key={region}
              className={`${styles.dropdown} ${
                region === (selectedRegion || defaultRegion)
                  ? styles.selected
                  : ""
              }`}
              onClick={() => {
                          onRegionChange && onRegionChange(region);
                          setOpen(false);
                        }}
                      >
                        {region}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <CourseInfo {...info.project} />
        <CourseInfo {...info.duration} />
        <CourseInfo {...info.session} />
      </div>
    </section>
  );
};

const CourseInfo = ({ label, value, description }) => (
  <div className={styles.inf_point}>
    <div className={styles.point}>{label}</div>
    <div className={styles.info}>{value}</div>
    {description && (
      <div className={styles.point_description}>{description}</div>
    )}
  </div>
);

export default TechCourseHeader;
